const config={
    "debugMode": location.hostname=="localhost"?true:false,
    "closedBeta": false,
    "beansitePlugins":[], // for future feature
};
export default config;